import script from "./userInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./userInfo.vue?vue&type=script&setup=true&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=4f3eafdd&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3eafdd"]])

export default __exports__